import { Element } from 'html-react-parser';
import type { HTMLReactParserOptions } from 'html-react-parser';

import safeParseHtml from './safeParseHtml';

interface ParseFillInTheBlanksProps {
  content: string;
  answers: string[];
  onChange: (value: string, index: number) => void;
}

const parseFillInTheBlanksHtml = ({
  content,
  answers,
  onChange
}: ParseFillInTheBlanksProps) => {
  let blankIndex = 0;

  const contentWithPlaceholders = content.replace(
    /{{blanks}}|{{blank}}/g,
    '<fill-blank></fill-blank>'
  );

  const options: HTMLReactParserOptions = {
    replace: (node) => {
      if (node instanceof Element && node.name === 'fill-blank') {
        const currentBlank = blankIndex;
        blankIndex += 1;

        const value = answers[currentBlank] ?? '';

        const minWidth = 48;
        const maxWidth = 252;

        const width = Math.min(
          maxWidth,
          Math.max(minWidth, (value.length + 1) * 12)
        );

        return (
          <input
            type="text"
            value={value}
            onChange={(event) => onChange(event.target.value, currentBlank)}
            style={{
              width: `${width}px`,
              maxWidth: `${maxWidth}px`
            }}
            className="mx-2 mb-2 inline-block h-11 rounded-lg border border-gray-300 text-center align-middle outline-none transition-[width] focus:border-primary"
          />
        );
      }

      return undefined;
    }
  };

  return safeParseHtml(contentWithPlaceholders, options);
};

export default parseFillInTheBlanksHtml;
